export class TimePeriod {
     name: string;
     value: number;
     constructor(name: string, value: number) {
          this.name = name;
          this.value = value;
     }
}